import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { goToLink } from "@actions/common";
import { useGetTenantStatisticsQuery } from "@api";
import { showAlert as showAlertAction } from "@components/alert/action";
import { openGame } from "@pages/casino/utils";

const useController = () => {
	const dispatch = useDispatch();
	const { data, isLoading } = useGetTenantStatisticsQuery();

	const redirect = useCallback(
		(...args) => {
			dispatch(goToLink(...args));
		},
		[dispatch]
	);

	const showAlert = useCallback(
		(...args) => {
			dispatch(showAlertAction(...args));
		},
		[dispatch]
	);

	const handleCardClick = (win) => {
		openGame(win, redirect, showAlert);
	};

	return {
		state: {
			lastWinners: data?.latestCasinoWins || [],
			isLoading,
		},
		handlers: { handleCardClick },
	};
};

export default useController;
